/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SourceContact } from './SourceContact';
import {
    SourceContactFromJSON,
    SourceContactFromJSONTyped,
    SourceContactToJSON,
    SourceContactToJSONTyped,
} from './SourceContact';

/**
 * 
 * @export
 * @interface CreateSourceContact201Response
 */
export interface CreateSourceContact201Response {
    /**
     * 
     */
    data?: SourceContact;
}

/**
 * Check if a given object implements the CreateSourceContact201Response interface.
 */
export function instanceOfCreateSourceContact201Response(value: object): value is CreateSourceContact201Response {
    return true;
}

export function CreateSourceContact201ResponseFromJSON(json: any): CreateSourceContact201Response {
    return CreateSourceContact201ResponseFromJSONTyped(json, false);
}

export function CreateSourceContact201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateSourceContact201Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : SourceContactFromJSON(json['data']),
    };
}

export function CreateSourceContact201ResponseToJSON(json: any): CreateSourceContact201Response {
    return CreateSourceContact201ResponseToJSONTyped(json, false);
}

export function CreateSourceContact201ResponseToJSONTyped(value?: CreateSourceContact201Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': SourceContactToJSON(value['data']),
    };
}

